import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

const heroSlides = [
  {
    title: '千万网红人设崩塌',
    subtitle: '私密聊天记录完整流出，揭露网红真实面目',
    link: '/article/dingzhen-chuxing-baoguang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20abstract%20background%20with%20shattered%20glass%20effect%2C%20warm%20crimson%20and%20deep%20amber%20tones%2C%20bold%20graphic%20composition%2C%20Chinese%20entertainment%20news%20aesthetic%2C%20high%20contrast%2C%20editorial%20design%2C%20dark%20dramatic%20atmosphere%2C%20no%20text&width=1600&height=700&seq=hero-slide-01&orientation=landscape',
  },
  {
    title: '顶流明星深夜秘密约会',
    subtitle: '狗仔独家拍摄画面曝光，粉丝群体彻底分裂',
    link: '/article/mingxing-yehuisinian',
    imageUrl: 'https://readdy.ai/api/search-image?query=Paparazzi%20night%20photography%20style%20abstract%20background%2C%20dramatic%20warm%20amber%20streetlights%20with%20motion%20blur%2C%20bold%20graphic%20composition%2C%20Chinese%20celebrity%20gossip%20aesthetic%2C%20high%20contrast%2C%20editorial%20design%2C%20dark%20mysterious%20atmosphere%2C%20no%20text&width=1600&height=700&seq=hero-slide-02&orientation=landscape',
  },
  {
    title: '知名主播偷税数千万',
    subtitle: '税务部门重拳出击，直播带货行业大地震',
    link: '/article/zhibozhujian-toumao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Financial%20investigation%20abstract%20background%20with%20official%20document%20textures%2C%20dramatic%20warm%20crimson%20and%20deep%20red%20tones%2C%20bold%20graphic%20composition%2C%20Chinese%20tax%20scandal%20aesthetic%2C%20high%20contrast%2C%20editorial%20design%2C%20serious%20dark%20atmosphere%2C%20no%20text&width=1600&height=700&seq=hero-slide-03&orientation=landscape',
  },
];

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % heroSlides.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="头条轮播">
      {heroSlides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <img
            src={slide.imageUrl}
            alt={slide.title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
        </div>
      ))}

      <div className="absolute inset-0 flex items-center">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="max-w-[40%] min-w-[320px]">
            <Link to={heroSlides[current].link} className="block cursor-pointer">
              <span className="inline-block text-xs bg-primary-500 text-background-50 px-3 py-1 rounded-full font-label mb-4">
                头条爆料
              </span>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight mb-3">
                {heroSlides[current].title}
              </h2>
              <p className="text-sm md:text-base text-background-200 leading-relaxed mb-6">
                {heroSlides[current].subtitle}
              </p>
              <span className="inline-flex items-center gap-2 whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-full font-label text-sm transition-colors cursor-pointer">
                查看详情
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50/20 hover:bg-background-50/40 flex items-center justify-center text-background-50 transition-colors cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50/20 hover:bg-background-50/40 flex items-center justify-center text-background-50 transition-colors cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === current ? 'bg-primary-500 w-6' : 'bg-background-50/40 hover:bg-background-50/60'
            }`}
            aria-label={`第${index + 1}张`}
          ></button>
        ))}
      </div>
    </section>
  );
}